import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79dd1893"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "projects",
  id: "projects"
}
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppProjectsBlock = _resolveComponent("AppProjectsBlock")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_AppProjectsBlock, { projects: _ctx.projects }, null, 8, ["projects"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppButton, {
        class: "projects__btn-show-all",
        theme: "dark",
        to: "/projects"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Смотреть все проекты ")
        ]),
        _: 1
      })
    ])
  ]))
}